export const DOOR_DETAILS_TABS = {
  ACTIVITY: {
    value: 'activity',
    title: 'Activity'
  },
  INDIVIDUALS: {
    value: 'individuals',
    title: 'Individuals',
  },

  entries: () => {
    return [
      DOOR_DETAILS_TABS.ACTIVITY,
      DOOR_DETAILS_TABS.INDIVIDUALS,
    ];
  },

  valueOf: (key) => {
    return DOOR_DETAILS_TABS.entries().find(e => e.value === key);
  },
};

// export const DOOR_DETAILS_INFO_TABS = {
//   CURRENT: {
//     value: 'current',
//     label: 'Current Equipment'
//   },
//   LAST24HOURS: {
//     value: 'last24',
//     label: 'Last 24 Hours',
//   },

//   entries: () => {
//     return [
//       DOOR_DETAILS_INFO_TABS.CURRENT,
//       DOOR_DETAILS_INFO_TABS.LAST24HOURS,
//     ];
//   },
// };

export const DOOR_FILTER_LEVELS = {
  DETAILS: {
    label: 'Details',
    value: 'details',
  },
  STATS: {
    label: 'Stats',
    value: 'stats',
  },

  entries: () => {
    return [
      DOOR_FILTER_LEVELS.DETAILS,
      DOOR_FILTER_LEVELS.STATS,
    ];
  },
};
